import * as shopApi from '../../api/shopApi';
import * as storeApi from '../../api/storeApi';

const state = {
  List: [],
  RepairStoreList:[],
}

const getters = {

}

const actions = {
  async GetStoreList({ commit }) {
    let response = await shopApi.GetStoreListByMerchantId()
    if (response.Status) {
      commit('setList', response.Data)
    }else{
      commit('setList', [])
    }
  },
  EmptyState({commit}){
    commit('emptyState');
  },
  async GetStoreListByRepair({ commit }) {
    // let response = await shopApi.GetStoreListByRepairStores()
    // 20190614 换用新的数据源
    let response = await storeApi.GetThirdWriteOffStores();
    if (response.Status) {
      commit('setRepairList', response.Data)
    }
    else{
      commit('setRepairList', [])
    }
  }
}

const mutations = {
  setList(state, list) {
    state.List = list
  },
  emptyState(state){
    state.List = []
  },
  setRepairList(state, list){
    state.RepairStoreList = list
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shop-list.js